<template>
    <div id="page-name" data-name="stocks">
      <!--Page Header-->
      <section class="page_header header_layout3 padding">
        <div class="container">
          <div class="header_content padding">
            <div class="row">
              <div class="col-md-12 text-center">
                 <h1 class="uppercase" style="font-size:50px">Акции и скидки</h1>
                 <p></p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="page_menu">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h3 class="hidden">hidden</h3>
              <ul class="breadcrumb">
                <li><a href="/">Главная</a></li>
                <li class="active">Акции</li>
              </ul>
            </div>
          </div>
        </div>
      </section>


      <!--BLog -->
      <section id="blog" class="margintop30">
      <h3 class="hidden">heading</h3>
        <div class="container">
          <div class="row">

              <article class="blog_item bottom_half row">
                <div class="blog_text col-sm-6 col-sm-push-6">
                  <ul class="meta margintop15 marginbottom15">
                    <li class="uppercase"></li>
                    <li class="uppercase"></li>
                    <li class="uppercase time pull-right"></li>
                  </ul>
                  <h5 class="uppercase marginbottom15">Пластиковые окна со <br>скидкой 50%</h5>
                  <p>Мы дарим скидку на всю профильную систему до 1 августа 50 %</p>
                </div>
                <div class="blog_image col-sm-6 col-sm-pull-6">
                  <img src="images/stocks/1.png" alt="blog">
<!--                  <a href="blog_post.html"><i class="fa fa-link"></i></a>-->
                </div>
              </article>
            <hr>
              <article class="blog_item bottom_half top_half row">
                <div class="blog_text col-sm-6">
                  <ul class="meta margintop15 marginbottom15">
                    <li class="uppercase"></li>
                    <li class="uppercase"></li>
                    <li class="uppercase time pull-right"></li>
                  </ul>
                  <h5 class="uppercase marginbottom15">Большой объём? Решили застеклить всю квартиру? <br>Или у вас более 5 окон?</h5>
                  <p>Скидка дополнительная на объём 18%</p>
                </div>
                <div class="blog_image col-sm-6">
                  <img src="images/stocks/3.png" alt="blog">
<!--                  <a href="blog_post.html"><i class="fa fa-link"></i></a>-->
                </div>
              </article>
            <hr>
              <article class="blog_item bottom_half top_half row">
                <div class="blog_text col-sm-6 col-sm-push-6">
                  <ul class="meta margintop15 marginbottom15">
                    <li class="uppercase"></li>
                    <li class="uppercase"></li>
                    <li class="uppercase time pull-right"></li>
                  </ul>
                  <h5 class="uppercase marginbottom15">Новоселы? Строите дом? Переехали в новую квартиру?</h5>
                  <p>Cкидка на все виды работ и остекление 10%</p>
                </div>
                <div class="blog_image col-sm-6 col-sm-pull-6">
                  <img src="images/stocks/2.png" alt="blog">
<!--                  <a href="blog_post.html"><i class="fa fa-link"></i></a>-->
                </div>
              </article>
            <hr>
              <article class="blog_item bottom_half top_half row">
                <div class="blog_text col-sm-6">
                  <ul class="meta margintop15 marginbottom15">
                    <li class="uppercase"></li>
                    <li class="uppercase"></li>
                    <li class="uppercase time pull-right"></li>
                  </ul>
                  <h5 class="uppercase marginbottom15">Скидка льготникам, бюджетникам 12%</h5>
                  <p></p>
                </div>
                <div class="blog_image col-sm-6">
                  <img src="images/stocks/4.png" alt="blog">
<!--                  <a href="blog_post.html"><i class="fa fa-link"></i></a>-->
                </div>
              </article>
            <hr>
              <article class="blog_item bottom_half top_half row">
                <div class="blog_text col-sm-6 col-sm-push-6">
                  <ul class="meta margintop15 marginbottom15">
                    <li class="uppercase"></li>
                    <li class="uppercase"></li>
                    <li class="uppercase time pull-right"></li>
                  </ul>
                  <h5 class="uppercase marginbottom15">Заказываете у нас не первый раз?</h5>
                  <p>Мы ценим своих клиентов. И дарим Вам дополнительно скидку 15%</p>
                </div>
                <div class="blog_image col-sm-6 col-sm-pull-6">
                  <img src="images/stocks/5.png" alt="blog">
<!--                  <a href="blog_post.html"><i class="fa fa-link"></i></a>-->
                </div>
              </article>

          </div>
<!--          <div class="row">-->
<!--            <div class="col-sm-12 text-center">-->
<!--              <ul class="pager">-->
<!--                <li><a href="#."><i class="fa fa-angle-left"></i></a></li>-->
<!--                <li class="active"><a href="#.">01</a></li>-->
<!--                <li><a href="#.">02</a></li>-->
<!--                <li><a href="#.">03</a></li>-->
<!--                <li><a href="#."><i class="fa fa-angle-right"></i></a></li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </section>

      <!--Slogan-->
      <section id="slogan" class="padding_bottom">
        <br><br>
        <div class="container sloganBg">
          <div class="row">
            <div class="col-md-12">
              <div class="left">
                <h2 class="uppercase">
                  <span style="color: #30ade7">с чего начать?
                  </span> Закажите обратный звонок
                </h2>
                <p style="color:#0f0f0f">Оставьте свою заявку, и наш менеджер перезвонит Вам в ближайшее время
                </p>
              </div>
              <div class="right">
                <a href="#"
                   class="btn-common uppercase"
                   style="color:white;background:rgb(255, 16, 20);border:1px solid white!important;padding:14px"
                  @click.prevent="backCallShow = true"
                >
                   Заказать обратный звонок
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <back-call :visibility="backCallShow" @closeDialog="closeDialog"/>
    </div>
</template>

<script>
  import BackCall from './modals/BackCall.vue'
  export default {
    components: { BackCall },
    name: "Stocks",
    data () {
      return {
        backCallShow: false,
      }
    },
    methods: {
      closeDialog() {
        this.backCallShow = false
      }
    }
  }
</script>

<style scoped>
  .blog_text h5{
    font-size: 26px;
    color: #0060aa;
    line-height: 140%;
  }
  .blog_text p{
    font-size: 16px;
  }
  .blog_text {
    padding-left: 30px;
  }

  .top_half {
    padding-top: 45px;
  }

  @media screen and (max-width: 1040px) {
    /*.bottom_half{*/
    /*  padding-bottom: 45px;*/
    /*}*/
    .top_half{
      padding-top: 0px;
    }
  }
</style>
